<div class="clearable" [ngClass]="{'has-label': !!label}">
  <form-input [placeholder]="placeholder" [label]="label" cssClass="is-search" [(ngModel)]="value"
              type="text"></form-input>
  <i class="clearable__clear" (click)="value = ''" *ngIf="value !== ''">&times;</i>
</div>
